import React, { useEffect } from 'react'
import './Homepage.css'
import { TfiUppercase } from "react-icons/tfi";
import { LiaSortNumericDownSolid } from "react-icons/lia";
import { MdSort } from "react-icons/md";
import { RxLetterCaseLowercase } from "react-icons/rx";
import { IoIosMore } from "react-icons/io";
// import { SignIn, baseUrl } from '../utils';
// import db, { auth } from '../firebase'
// import { getDeviceToken } from '../utils'
// import { onAuthStateChanged } from 'firebase/auth';
import ReactGA from 'react-ga4'
import {  useNavigate } from "react-router-dom";

function Homepage() {

    // const [userAuth, setUserAuth] = useState()
    const navigate = useNavigate()

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Home page" });
    }, [])

    // useEffect(() => {
    //     const unsubscribe = onAuthStateChanged(auth, (user) => {
    //         if (user) {
    //             setUserAuth(user);
    //         } else {
    //             setUserAuth(null);
    //         }
    //     });

    //     return () => unsubscribe();
    //     // eslint-disable-next-line
    // }, [auth])


    const handleGuest = async () => {
        ReactGA.event({
            action: "Continue as Guest",
            category: "User interaction",
            label: "Continue as Guest"
        })

        navigate("/format")

        // const token = await getDeviceToken()
        // if (token === undefined) {
        //     alert('Please enable Push notification')
        //     return
        // }
        // const dbCollection = await db.collection('deviceTokens')
        //     .doc(token)
        // // .get()

        // if (userAuth) {
        //     window.alert('You are Already Logged in')

        // } else {
        //     dbCollection.get().then((doc) => {
        //         if (doc.exists) {
        //             // Access the document data using doc.data()
        //             const data = doc.data();
        //             // check for 10 Uses
        //             if (data.Uses < 10) {
        //                 // if < 10 uses then redirect to /format as guest
        //                 // navigate('/format')
        //                 window.location.href = baseUrl + '/format'
        //             } else {
        //                 // else ask for email
        //                 alert('Please Sign up using Google')
        //             }
        //             console.log('Document data:', data);
        //         } else {
        //             // create a new document with given token and redirect to /format as guest
        //             let newData = {
        //                 "Email": "",
        //                 "Uses": 0
        //             }
        //             db.collection('deviceTokens').doc(token).set(newData).then(() => {
        //                 console.log('Document successfully added with custom ID!');
        //                 window.location.href = baseUrl + '/format'

        //             }).catch((error) => {
        //                 console.error('Error adding document: ', error);
        //             });
        //         }
        //     })
        //         .catch((error) => {
        //             console.error('Error getting document:', error);
        //         });
        // }
    }


    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };


    return (
        <div className="homepage">
            <main>
                <section>
                    <h1>FORMAT WITH ONE CLICK</h1>
                    <p>Capitalize, sort social media posts for X, LinkedIn, Facebook and much more</p>
                    <div className='button_div'>
                        {/* <button className='signup_button' onClick={SignIn}>Start Formatting</button> */}
                        <button className='signup_button' onClick={handleGuest}>Start Formatting</button>
                    </div>
                    <video src="/assets/Formatr Landing Page Video.m4v" className='demo_video' autoPlay={true} muted loop>
                    </video>
                </section>
            </main>
            <section>
                <p>Create content that Reach Eye Balls</p>
                <div className='social_icons'>
                    <img src="/assets/Twitter.jpg" alt="twitter" />
                    <img src="/assets/LinkedIn.jpg" alt="LinkedIn" />
                    <img src="/assets/Facebook.jpg" alt="Facebook" />
                    <img src="/assets/Instagram.jpg" alt="Instagram" />
                    <img src="/assets/Threads.jpg" alt="Threads" />
                </div>
                <button className='signup_button' onClick={handleGuest}>Start Formatting</button>

            </section>
            <section>
                <p id="features"    >Our Features</p>
                <div className='feature_icons'>
                    <span title="Uppercase text"><TfiUppercase size='40px' /></span>
                    <span title="Lowercase text"> <RxLetterCaseLowercase size='40px' /></span>
                    <span title="Add Emojis">🚀</span>
                    <span title="Add Numbered list"><LiaSortNumericDownSolid size='40px' /></span>
                    <span title='Sort According to length of words'><MdSort size='40px' /></span>
                    <span title='more'><IoIosMore size='40px' /></span>
                </div>
                <p className='features' >
                    Unlock seamless Text Formatting with Formatr! Elevate your social media game effortlessly. From basic text formatting to captivating posts
                </p>
            </section>
            <section>
                <p>Coming Soon...</p>
                <p className='features'>
                    Live Social media preview
                </p>
                <div className='button_div'>
                <button className='signup_button' onClick={handleGuest}>Start Formatting</button>
                 </div>
            </section>
            <footer>
                <div className='footer_container'>
                    <div className='socials'>
                        <span><a href="https://www.twitter.com/@BandhaNimish" target='_blank' rel="noreferrer">X (Twitter)</a></span>
                        <span><a href="https://instagram.com/programmer_nimish" target='_blank' rel="noreferrer">Instagram</a></span>
                    </div>
                    <div className='footer_buttons'>
                        <span onClick={() => scrollToSection('features')}>Features</span>
                        <span onClick={handleGuest}>Start Formatting</span>
                        {/* <span onClick={SignIn}>Sign up/ Login</span> */}

                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Homepage